import { useEffect, useState } from 'react'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { useSelector } from 'react-redux'
import { selectCurrentContractActive } from '../SubscriptionForm/SubscriptionFormSelectors'
import { useTranslation } from 'react-i18next'

const useSaleFormObserver = (type, country, id) => {
  const { t } = useTranslation()
  const [validations, setValidations] = useState(null)
  const { addErrorToContract } = useFormStatus()
  const contract = useSelector(selectCurrentContractActive)
  const upperCaseCountry = country.toUpperCase()
  const firstUpperCaseType = type.charAt(0).toUpperCase() + type.slice(1)
  const calculateMissingFields = async () => {
    const validations = await import(`./${firstUpperCaseType}/validation/${upperCaseCountry}/validation.js`)
    if (validations.default && Object.keys(validations.default).length > 0) {
      setValidations(validations.default)
      Object.keys(validations.default).forEach(key => {
        const isValid = validations.default[key](contract, true)
        if (!isValid) {
          addErrorToContract(id, {
            [key]:
              t(`subscriptionForm:validation_errors_v2.${key}`) ??
              `Field ${key} is missing in validation list translations`,
          })
        }
      })
    }
  }

  useEffect(() => {
    calculateMissingFields()
  }, [])

  return { validations }
}

export default useSaleFormObserver
